import React from "react";
import ReactModal from "react-modal";
import ClassNames from "classnames";
import "./modal.css";
import * as s from "./s.module.scss"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

 
//ReactModal.setAppElement("#___portal");

class ModalRegular extends React.Component {
  render() {
    const { children, isOpen, onRequestClose, modalOverlayClassName } = this.props;

    return (
      <ReactModal
      closeTimeoutMS={400}
      className={s.modal}
      overlayClassName={ClassNames(s.modalOverlay, modalOverlayClassName)}
      bodyOpenClassName={s.modalBodyOpen}
      isOpen={isOpen}
      shouldCloseOnOverlayClick={true}
      onRequestClose={onRequestClose}
    >
      <div className={s.modalHeader}>
        <FontAwesomeIcon
          className={s.modalCloseButton}
          onClick={onRequestClose}
          icon={faTimes}
        />
      </div>
      <div className={s.modalInnerContent}>{children}</div>
    </ReactModal>
    );
  }
}

export default ModalRegular;
